import React from 'react';
import { Overlay } from 'react-overlays';

// This is a component that wraps an Overlay and inserts its children into that
// Overlay. The Overlay is sneaky in that it passes style props to the children
// internally, (as opposed to passing props in the JSX that we write). We have
// to be aware of those and apply them to the Overlay children to benefit from
// the positional computations of the Overlay. This component just applies that
// style for us so that each presentational component that appears in an Overlay
// doesn't have to know about this.
const Modal = ({children, onHide, ...rest}) => (
  <Overlay {...rest}>
    <ModalWrapper onHide={onHide}>
      {children}
    </ModalWrapper>
  </Overlay>
);

Modal.propTypes = {
  ...Overlay.propTypes,
};

const ModalWrapper = ({style, onHide, children}) => (
  <div className="Modal">
    <div className="Modal__cancelRegion" onClick={onHide} />
    <div className="Modal__content" style={style}>
      {children}
    </div>
  </div>
);

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js